import type { POSSourceParser, POSImportData, OutletLocationMapping } from './types';

export const DimePOSParser: POSSourceParser = {
  id: 'dimepos',
  name: 'DimePOS',
  description: 'Import products from a DimePOS export',
  acceptedFileTypes: ['.csv', '.xlsx'],
  isAvailable: false,

  async detectOutlets(_file: File): Promise<string[]> {
    throw new Error('DimePOS import is not yet available');
  },

  async parse(
    _file: File,
    _outletMapping?: OutletLocationMapping
  ): Promise<POSImportData> {
    throw new Error('DimePOS import is not yet available');
  },
};
